import React from 'react';
import { shape, number, bool, string } from 'prop-types';
import classNames from 'classnames';
import { Typography } from '@one-thd/sui-atomic-components';
import VisualTabs from './VisualTabs';

const CollectionsTitle = (props) => {
  const {
    metadata,
    productIdentifier,
    isMobile,
    isCategoryTab,
    colSpanClasses,
    recsCollectionTabCount,
    categories,
    pullFilteredData,
    products,
    experienceName
  } = props;

  const titleClasses = classNames('sui-grid', 'sui-grid-cols-1', { 'sui-pt-8': !isMobile && experienceName },
    { 'sm:sui-grid-cols-3': (metadata?.collectionImageUrl && !experienceName) });

  const productBrandName = productIdentifier?.brandName;

  return (
    <div className={titleClasses}>
      <div>
        {metadata?.collectionTitle1 ? (
          <div className="sui-pb-2 sm:sui-pb-0">
            <Typography variant="h3">{metadata?.collectionTitle1}</Typography>
          </div>
        ) : (
          <div className="sui-pb-2 sm:sui-pb-0">
            <Typography variant="h3">{productBrandName}</Typography>
          </div>
        )}

        {metadata?.collectionTitle2 && (
          <div className="sui-pb-2 sm:sui-pb-0">
            <Typography variant="body-base" weight="bold" component="h3">{metadata?.collectionTitle2}</Typography>
          </div>
        )}
      </div>
      {experienceName ? <div className="sui-pt-4"> Find items that go well together </div> : ''}
      {!isMobile && isCategoryTab && (
        <div className={colSpanClasses}>
          {isCategoryTab && categories?.length > 0 && categories?.length >= recsCollectionTabCount && (
            // eslint-disable-next-line max-len
            <VisualTabs products={products} categories={categories} filterItemIds={pullFilteredData} />
          )}
        </div>
      )}
    </div>
  );
};

CollectionsTitle.propTypes = {
  metadata: shape({
  }),
  productIdentifier: shape({
  }),
  isMobile: bool,
  recsCollectionTabCount: number,
  isCategoryTab: bool,
  experienceName: string,
  categories: shape({
  }),
  products: shape({
  }),
  pullFilteredData: shape({
  }),
  colSpanClasses: string
};

CollectionsTitle.defaultProps = {
  metadata: {},
  productIdentifier: {},
  isMobile: false,
  recsCollectionTabCount: 4,
  isCategoryTab: false,
  experienceName: null,
  categories: {},
  products: {},
  pullFilteredData: {},
  colSpanClasses: null
};

export default CollectionsTitle;